import { useAppSelector } from './useAppStore';

/**
 * Contexto de tenant EFECTIVO.
 *
 * Cuando el staff de plataforma (booster_admin/booster_support) "entró" a un tenant
 * (`actingTenant`), devuelve el contexto de ESE tenant — modo, features de plan y
 * branding — para que el CRM se pinte como el del tenant en modo soporte.
 * Fuera del modo soporte, cae al contexto del usuario logueado (`auth.user`).
 */
export function useEffectiveTenant() {
  const user   = useAppSelector((s) => s.auth.user);
  const acting = useAppSelector((s) => s.auth.actingTenant);

  const isActing   = !!acting;
  const tenantMode = acting ? acting.mode : user?.tenantMode;
  /**
   * País del tenant EFECTIVO, ISO-2. En modo soporte es el del tenant que se está
   * mirando, no el de quien mira: el sello del sidebar tiene que decir sobre qué mercado
   * es la pantalla que se ve.
   */
  const tenantCountry = acting ? acting.country : user?.tenantCountry;
  const branding   = acting ? (acting.branding ?? undefined) : user?.tenant?.branding;

  // Gateo por plan: nativo (Imperium) o sin plan → acceso full; booster → según features.
  let native: boolean;
  let features: string[];
  let hasPlan: boolean;
  if (acting) {
    native   = acting.native ?? acting.mode === 'native';
    features = acting.features ?? [];
    hasPlan  = true; // al entrar resolvemos el plan real del tenant
  } else {
    const sub = user?.subscription;
    native   = sub?.native ?? true;
    features = sub?.features ?? [];
    hasPlan  = !!sub;
  }
  const hasPlanFeature = (feat: string) => (!hasPlan || native ? true : features.includes(feat));

  return { isActing, tenantMode, tenantCountry, native, features, branding, hasPlanFeature };
}
